import { IOptionAnyValue } from 'bricks/types';
import { IPropertyType } from '../../types';

export interface BOESlideoutFormValues {
    id: string | null;
    dealId: number | null;
    name: string;
    propertyType: IOptionAnyValue;
    selectedLoanCalculationOptions: any;
    grossSquareFootage: number | null;
    efficiency: number | null;
    rentPrice: number | null;
    units: number | null;
    expenses: number | null;
    exitCapRate: number | null;
    acquisitionCosts: number | null;
    hardCosts: number | null;
    softCosts: number | null;
    developerFee: number | null;
    apr: number | null;
    avgLoanBalance: number | null;
    loanTerm: number | null;
    contructionFinancing: number | null;
    marketCapRate: number | null;
    developerFeeTotal: number | null;
    interestReserveTotal: number | null;
    totalDevelopmentCosts: number | null;
    loanAmount: number | null;
    equityCost: number | null;
    rentPriceSubdiv: 'unit' | 'sf' | 'kw' | 'mw';
    expenseCostSubdiv: 'unit' | 'sf' | 'kw' | 'mw';
    softCostsSubdiv: 'unit' | 'sf' | 'kw' | 'mw' | 'total';
    hardCostsSubdiv: 'unit' | 'sf' | 'kw' | 'mw' | 'total';
    rentPriceTime: 'monthly' | 'yearly';
    expenseCostTime: 'monthly' | 'yearly';
    loanTermTime: 'monthly' | 'yearly';
    isNewScenario?: boolean;
    createNewDeal?: boolean;
}

export const BOE_FIELD: { [K in keyof BOESlideoutFormValues]: K } = {
    id: 'id',
    dealId: 'dealId',
    name: 'name',
    propertyType: 'propertyType',
    selectedLoanCalculationOptions: 'selectedLoanCalculationOptions',
    grossSquareFootage: 'grossSquareFootage',
    efficiency: 'efficiency',
    rentPrice: 'rentPrice',
    units: 'units',
    expenses: 'expenses',
    exitCapRate: 'exitCapRate',
    acquisitionCosts: 'acquisitionCosts',
    hardCosts: 'hardCosts',
    softCosts: 'softCosts',
    developerFee: 'developerFee',
    apr: 'apr',
    avgLoanBalance: 'avgLoanBalance',
    loanTerm: 'loanTerm',
    contructionFinancing: 'contructionFinancing',
    marketCapRate: 'marketCapRate',
    developerFeeTotal: 'developerFeeTotal',
    interestReserveTotal: 'interestReserveTotal',
    totalDevelopmentCosts: 'totalDevelopmentCosts',
    loanAmount: 'loanAmount',
    equityCost: 'equityCost',
    rentPriceSubdiv: 'rentPriceSubdiv',
    expenseCostSubdiv: 'expenseCostSubdiv',
    softCostsSubdiv: 'softCostsSubdiv',
    hardCostsSubdiv: 'hardCostsSubdiv',
    rentPriceTime: 'rentPriceTime',
    expenseCostTime: 'expenseCostTime',
    loanTermTime: 'loanTermTime',
    isNewScenario: 'isNewScenario',
    createNewDeal: 'createNewDeal',
};

export interface IBackOfEnvelopePayload {
    dealId: number | null;
    name: string;
    builtSf: number;
    buildingEfficiency: number;
    monthlyRentPricePerUnit?: number;
    monthlyRentPricePerSf?: number;
    rentPriceTime: 'monthly' | 'yearly';
    rentPriceSubdiv: 'unit' | 'sf' | 'kw' | 'mw';
    numberOfUnits: number;
    monthlyExpenseCostPerUnit?: number;
    monthlyExpenseCostPerSf?: number;
    expenseCostTime: 'monthly' | 'yearly';
    expenseCostSubdiv: 'unit' | 'sf' | 'kw' | 'mw';
    assumedExitCapRate: number;
    acquisition: number;
    hardCosts?: number;
    hardCostsSubdiv: 'unit' | 'sf' | 'kw' | 'mw' | 'total';
    softCosts?: number;
    softCostsSubdiv: 'unit' | 'sf' | 'kw' | 'mw' | 'total';
    developerFeeRate: number;
    annualPercentageRate: number;
    averageLoanBalance: number;
    loanTermMonths: number;
    loanTermTime: 'monthly' | 'yearly';
    propertyTypeId: number;
    propertyType?: IPropertyType;
    loanToCost?: number;
    loanToValue?: number;
    debtYield?: number;
    id?: number;
    marketCapRate?: number;
}

export interface IVariables {
    postData: IBackOfEnvelopePayload;
    orgId: string;
}
